import { useContext } from 'react';
import { CommentEditorContext, EditorContext } from '../context';
/**
 * Returns true if the editor is empty, regardless of if the user is
 * using the full featured editor or the fallback editor.
 */ export function useIsCommentEditorEmpty() {
    const { shouldUseFallback , isFallbackEmpty  } = useContext(CommentEditorContext);
    const { state: editorState  } = useContext(EditorContext);
    if (shouldUseFallback) {
        return isFallbackEmpty;
    }
    if ((editorState === null || editorState === void 0 ? void 0 : editorState.isEmpty) !== undefined) {
        return editorState.isEmpty;
    }
    return true;
}
